<article class="podcast-item">
  <a class="podcast-image" [responsiveBackgroundImage]="show.logo_square || show.logo1"
    [widthFactor]="0.1"
    (click)="toggleAlteredView()" aria-hidden="true"></a>
  <div class="podcast-details">
    <a class="view-lastest-episode-link"
       routerLink="/shows/{{show.slug || show.id}}/podcasts">
      <img src="/assets/podcasts/view-latest-icon.png" alt="">
      Listen to Latest Episodes
    </a>
    <a class="podcast-name" (click)="toggleAlteredView()">{{show.name}}</a>

    <p class="podcast-description">
        <span class="podcast-badges">
          <ng-container *ngIf="show.is_premium">
            <tyt-plus-tag *ngIf="audienceType === 'member'"></tyt-plus-tag>
            <tyt-plus-locked *ngIf="audienceType !== 'member'"></tyt-plus-locked>
          </ng-container>

          <a class="subscribe-badge" (click)="toggleAlteredView()">
            <span class="rss-icon"></span>
            {{ subscribed ? 'Subscribed' : 'Subscribe' }}
          </a>
        </span>
      {{ show.description }}
    </p>
    <ng-container *ngIf="showAlteredView">
      <div class="subscribe-rss-container">
        <a (click)="showRSS(show)">
          <span class="subscribe-rss-text">{{rssFeedText}}</span>
          <span class="subscribe-rss-icon"></span>
        </a>
      </div>
      <span class="subscribe-tuneIn-leyend">Paste link into your favorite podcasting app.</span>
      <ng-container *ngIf="showTuneInPlatforms">
        <div class="subscribe-tuneIn-divider"></div>
        <span class="subscribe-tuneIn-leyend">Or listen for free (with ads) on these platforms.</span>
        <div class="subscribe-tuneIns">
          <a class="subscribe-tuneIn" target="_blank" href="{{destination.url}}" *ngFor="let destination of podcastTuneIn.destinations">
            <img class="subscribe-logo" src="{{destination.logo_brick || destination.logo_square || destination.logo}}"/>
          </a>
        </div>
      </ng-container>
    </ng-container>
  </div>
  <div class="background-image">{{show.web_header_image}}</div>
</article>
